import { chain, keyBy, map, sortBy } from "lodash"

export const makeBoardViewModel = (boardData: any): BoardViewModel => {
  const orderedColumns = sortBy(boardData.columns, "position")
  const allIds = map(orderedColumns, "id")
  const orderedVisibleColumnIds = chain(orderedColumns)
    .filter((col) => col.isVisible)
    .map("id")
    .value()
  const columnsById = chain(orderedColumns)
    .map((col) => {
      return {
        ...col,
        cards: {
          byId: keyBy(col.cards, "id"),
          allIds: map(col.cards, "id"),
        },
      }
    })
    .keyBy("id")
    .value()

  return {
    id: boardData.id,
    type: boardData.type,
    isProjectBoard: boardData.type === "project",
    isTaskBoard: boardData.type === "task",
    isUserBoard: boardData.type === "user",
    isMemberBoard: boardData.type === "member",
    isCustomerBoard: boardData.type === "customer",
    isSupplierBoard: boardData.type === "supplier",
    isWorkspaceBoard: boardData.type === "workspace",
    columns: {
      allIds,
      byId: columnsById,
      orderedVisibleColumnIds,
    },
  }
}

export type BoardViewModel = {
  id: string
  type: string
  isProjectBoard: boolean
  isTaskBoard: boolean
  isUserBoard: boolean
  isMemberBoard: boolean
  isCustomerBoard: boolean
  isSupplierBoard: boolean
  isWorkspaceBoard: boolean
  columns: {
    byId: { [k: string]: any }
    orderedVisibleColumnIds: string[]
    allIds: string[]
  }
}
